import axiosInstance from "../config/axios.config";

export const getBillingDetailsApi = (admissionId) => {
  return axiosInstance.get(`/billing/view/op/${admissionId}/`);
};

export const getPatientServicesApi = (admissionId) => {
  return axiosInstance.get(`/outpatient/patient-services/?admission_id=${admissionId}`);
};

export const assignServiceToPatientApi = (payload) => {
  return axiosInstance.post(`/outpatient/patient-services/`, payload);
};
export const markServicesDoneApi = (payload) => {
  return axiosInstance.patch(`/outpatient/services/bulk-action/`, payload);
};
export const deleteServicesApi = (payload) => {
  return axiosInstance.delete(`/outpatient/services/bulk-action/`, { data: payload });
};
export const recordPaymentApi = (billId, payload) => {
  return axiosInstance.post(`/billing/payment/${billId}/`, payload);
};


